import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { NotifyScopeAggregate } from '../aggregate/notify-scope-aggregate';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var NOTIFY_SCOPE_AGGREGATE_KEY = 'mainINotifyScope';
var NotifyScopeDomainService = /** @class */ (function () {
    function NotifyScopeDomainService() {
        this.notifyScopeAggregate = new NotifyScopeAggregate(NOTIFY_SCOPE_AGGREGATE_KEY);
    }
    /**
     * 初始化 NotifyScope 领域
     * 无需初始化，提供空实现
     */
    NotifyScopeDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotifyScopeDomainService.prototype, "init", null);
    return NotifyScopeDomainService;
}());
export { NotifyScopeDomainService };
